export default {
    data(){
        return {
            currentMonth: null,
            currentInterval: null,
            now: new Date(),
            monthlyIndex: {}
        };
    },
    methods: {
        handleMonthChange(month, begin, end){
            this.currentMonth = month;
            this.currentInterval = [begin, end];

            this.requestMonthData();
        }
    }
}